/**
 * Wahler-Backend
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export enum InvoiceStatus {

    SENT = 'SENT',

    PAID = 'PAID',

    OVERDUE = 'OVERDUE',

    CANCELLED = 'CANCELLED'
}

